import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { CartContext } from '../CartProvider';
import analytics from '../utils/analytics';
import { trackCartEvent } from '../utils/cartTelemetry';
import { reportMetaEvent } from '../utils/consentScripts';
import './ShoppingCart.css';

export function ShoppingCart() {
  const { cart, dispatch } = useContext(CartContext);
  const [productDetails, setProductDetails] = useState(null);
  const [totalPrice, setTotalPrice] = useState(null);
  const [deliveryCosts, setDeliveryCosts] = useState(null);
  const [deliveryTime, setDeliveryTime] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    loadProducts();
  }, []);

  useEffect(() => {
    loadProducts();
  }, [cart]);

  const handleQuantityChange = (id, quantity) => {
      if (Number(quantity) > 0) {
        trackCartEvent('update', [{ id, quantity }],
          cart.map(c => ({ id: c.id, quantity: c.id === id ? quantity : c.quantity })));
      }
      dispatch({ type: 'UPDATE_ITEM', payload: {
        id: id,
        quantity: quantity
      }
    });
  };

  const handleRemoveFromCart = (id) => {
    const removed = cart.find(c => c.id === id);
    trackCartEvent('remove', [{ id, quantity: removed ? removed.quantity : 1 }],
      cart.filter(c => c.id !== id).map(c => ({ id: c.id, quantity: c.quantity })));
    dispatch({ type: 'REMOVE_ITEM', payload: {
        id: id
      }
    });
  };

  const handleCheckoutNew = () => {
    trackCartEvent('checkout', [], cart);
    try {
      // send begin_checkout with cart items and total if available
      const items = (productDetails || []).map(p => ({
        item_id: p.identifier,
        item_name: p.name,
        quantity: p.quantity,
        price: parseFloat(String(p.unitPrice).replace(',', '.').replace(/[^0-9.-]+/g, '')) || 0
      }));

      const value = parseFloat(String(totalPrice).replace(',', '.').replace(/[^0-9.-]+/g, '')) || undefined;

      analytics.sendEvent('begin_checkout', {
        items,
        value,
        currency: (productDetails && productDetails.length && productDetails[0].currency) || 'EUR'
      });
    } catch (e) {
      // ignore analytics errors
    }

    reportMetaEvent('InitiateCheckout', {
      content_ids: (productDetails || []).map(p => p.identifier),
      content_type: 'product',
      num_items: (productDetails || []).reduce((sum, p) => sum + (parseInt(p.quantity) || 1), 0),
      value: parseFloat(String(totalPrice).replace(',', '.').replace(/[^0-9.-]+/g, '')) || undefined,
      currency: (productDetails && productDetails.length && productDetails[0].currency) || 'EUR'
    });

    navigate('/checkoutAddress');
  }

  const loadProducts = () => {
    // Prepare the cart data
    const cartData = cart.map(item => ({ key: item.id, value: item.quantity }));

  // Fetch product details
  fetch('api/Product/GetProductDetails', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(cartData),
  })
    .then(response => response.json())
    .then(data => 
      {
        setProductDetails(data.products);
        setTotalPrice(data.totalPrice);
        setDeliveryCosts(data.deliveryCost);
        setDeliveryTime(data.deliveryTime);
      });
  }

  return (
    <div>
      <h1 style={{ marginBottom: '40px' }}>Warenkorb</h1>
      <div className="product-details-container">
          {productDetails && productDetails.map((productDetail) => (
              <div key={productDetail.identifier} className="product-detail-item">
                  <img src={productDetail.image} alt={productDetail.name} className="product-imagesc" />
                  <p className="product-item-name">{productDetail.name}</p>
                  <p className="product-unit-price">{productDetail.unitPrice}</p>
                  <p className="product-total-price">{productDetail.totalPrice}</p>
                  <div className="product-qty-delete">
                      <input
                          type="number"
                          min="1"
                          value={productDetail.quantity}
                          onChange={(e) => handleQuantityChange(productDetail.identifier, e.target.value)}
                      />
                      <img
                          width='18px'
                          height='auto'
                          style={{ cursor: 'pointer', opacity: 0.5, transition: 'opacity 0.2s' }}
                          onMouseEnter={e => e.currentTarget.style.opacity = '1'}
                          onMouseLeave={e => e.currentTarget.style.opacity = '0.5'}
                          src="/imgs/recycle-bin.png"
                          alt="delete"
                          onClick={() => handleRemoveFromCart(productDetail.identifier)}
                      />
                  </div>
              </div>
          ))}
      </div>
      <div style={{ marginBottom: '32px', borderTop: productDetails && productDetails.length ? 'none' : '1px solid #D4D2CB' }}>
        <p style={{ fontFamily: "'Inter', sans-serif", fontSize: '13px', color: '#868686', textAlign: 'right', margin: '8px 0' }}>{deliveryCosts}</p>
        <p style={{ fontFamily: "'Inter', sans-serif", fontSize: '13px', color: '#868686', textAlign: 'right', margin: '8px 0' }}>{deliveryTime}</p>
        <p style={{ fontFamily: "'Inter', sans-serif", fontSize: '16px', fontWeight: 600, color: '#5A5A5A', textAlign: 'right', margin: '12px 0 4px' }}>Gesamtpreis*: {totalPrice}</p>
        <p style={{ fontFamily: "'Inter', sans-serif", textAlign: 'right', fontSize: '11px', color: '#B0ADA7' }}>* Umsatzsteuer wird nicht erhoben gemäß §19UStG</p>
      </div>
      <div style={{ marginBottom: '60px', display: 'flex', justifyContent: 'flex-end' }}>
        <button style={{ width: '220px' }} className="global-button" onClick={handleCheckoutNew} disabled={!cart.length}>Zur Kasse</button>
      </div>
    </div>
  );
}
